import React from 'react';
import PropTypes from 'prop-types';
import loader from '../../../assets/loading.gif';

const SubmitContactUsButton = (props) => {
  const { id, error, anyTouched, invalid, dirty, submitFailed, submitting } = props;
  return (
    <div>
      {error &&
      <div className="contact-us-error">{error}</div>
      }
      {anyTouched && invalid && dirty && submitFailed &&
      <div className="contact-us-error">Please complete all required fields</div>
      }
      <div>
        Email conversations will be recorded for quality and training purposes
        and to assist in resolving disputes.
      </div>
      <div className="contact-us-button-container">
        <button id={id} className="btn btn-default contact-us-button" type="submit" disabled={submitting}>
          {submitting ?
            <img
              src={loader}
              height="20"
              alt="Loading..."
              role="presentation"
            /> : 'SEND'}
        </button>
      </div>
    </div>
  );
};

SubmitContactUsButton.propTypes = {
  id: PropTypes.string,
  submitting: PropTypes.bool,
  anyTouched: PropTypes.bool,
  submitFailed: PropTypes.bool,
  dirty: PropTypes.bool,
  error: PropTypes.string,
  invalid: PropTypes.bool
};

export default SubmitContactUsButton;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/SubmitContactUsButton/SubmitContactUsButton.js
 **/